package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetSentencesResponse(
    val data: List<GetSentencesData>,
)
@Serializable
data class GetSentencesData(
    val id: String = "",
    val rev: String = "",
    val domainType: String = "",
    val endTime: Double = 0.0,
    val keywords: List<Keyword> ? = emptyList(),
    val names: List<Name>? = emptyList(),
    val language: String = "",
    val organization: String = "",
    val sessionDateTimes: String = "",
    @SerialName("sessionID")
    val sessionId: String = "",
    val sessionType: String = "",
    val startTime: Double = 0.0,
    val totalTime: Double = 0.0,
    var transcript: String = "",
    var notes: String = "",
    var coachName: String = "",
    var coachFirstName: String = "John",
    var coachLastName: String = "Doe",
    val tagPlayers: List<String>?=emptyList(),
    val tagCoaches: List<String>?=emptyList(),
    val type: String = "",
    @SerialName("userID")
    val userId: String = "",
    val videoFile: String = "",
    val category : String? = null,
    val wordCount: Int = 0,
    val emotions: String = "",
    val sentiment: String = "",
    val tone: String = "",
)
@Serializable
data class Keyword(
    val domainType: String = "",
    val keyWordType: String = "",
    val keywordCategory: String = "",
    val nameCategory: String = "",
    val language: String = "",
    val organization: String = "",
    val sessionDateTime: String = "",
    @SerialName("sessionID")
    val sessionId: String = "",
    val text: String = "",
    val usageCount: Int=0,
    @SerialName("userID")
    val userId: String = "",
)

@Serializable
data class Name(
    val domainType: String = "",
    val keyWordType: String = "",
    val language: String = "",
    val nameCategory: String = "",
    val organization: String = "",
    val seasonID: String = "",
    val sessionDateTime: String = "",
    @SerialName("sessionID")
    val sessionId: String = "",
    val text: String = "",
    val usageCount: Int = 0,
    @SerialName("userID")
    val userId: String = "",
)